import React, { FC } from 'react'
import Input from '@vtex/styleguide/lib/Input'
import { injectIntl } from 'react-intl'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import { InputFieldProps } from './types'
import InputButton from '@/checkout-instore-legacy/commons/components/InputButton'
import { validateEmail } from '@/checkout-instore-legacy/utils/EmailUtils'
import isEmpty from 'lodash/isEmpty'

const InputField: FC<InputFieldProps> = ({
  field,
  data,
  inputRef,
  onChange,
  onBlur,
  options,
  intl,
  mediaQuery,
  loading,
}) => {
  const labelInput = intl.formatMessage({
    id: `profile-form.field.${field.label}`,
  })
  const optionalInput = intl.formatMessage({
    id: `profile-form.optional`,
  })
  const mobile = mediaQuery({
    phone: true,
    tablet: false,
    desktop: false,
  })
  const fieldSize = mobile ? 'regular' : 'large'
  const PHONE_FIELD = 'hone'
  const element = (
    <div className="flex flex-auto">
      {`${labelInput}`}
      {!field.required && field.name !== 'stateRegistration' && (
        <div className="flex-auto c-muted-1 t-small-ns ml3 mt1 t-mini-s">{`${optionalInput}`}</div>
      )}
    </div>
  )
  const onClick = () => {
    options.onClick()
  }
  const profileId = (name: string) => {
    if (name.endsWith(PHONE_FIELD)) {
      return name === 'homePhone' ? 'phone' : 'corporatePhone'
    }
    return name === 'stateRegistration' ? 'stateInscription' : name
  }

  // @ts-expect-error ts-migrate(7030) FIXME: Not all code paths return a value.
  const errorMessage = () => {
    if (!field.disabled && data.error) {
      return intl.formatMessage({
        id: `profile-form.error.${data.error}`,
      })
    }
  }

  return (
    <div className="pb5" data-testid={field.name}>
      {field.name !== 'email' && (
        <Input
          name={field.name}
          id={profileId(field.name)}
          dataAttributes={{
            cy: field.name,
          }}
          label={element}
          autoFocus={!isEmpty(data.value)}
          value={field.disabled ? '' : data.value || ''}
          errorMessage={errorMessage()}
          onChange={(e: InputValueEvent) => onChange(e)}
          onBlur={(e: InputValueEvent) => onBlur(e)}
          ref={inputRef}
          placeholder={field.disabled ? field.placeholder || '' : ''}
          maxLength={field.maxLength}
          disabled={field.disabled || loading}
          size={fieldSize}
        />
      )}
      {field.name === 'email' && (
        <div data-cy="email-submit">
          <InputButton
            buttonProps={{
              disabled: loading || !validateEmail(data.value),
              isLoading: loading,
              type: 'button',
              text: intl.formatMessage({
                id: `profile-form.button.submit`,
              }),
              size: mobile ? 'small' : 'regular',
              onClick: onClick,
            }}
            id="email"
            label={labelInput}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                onClick()
                event.preventDefault()
              }
            }}
            errorMessage={
              data.error &&
              intl.formatMessage({
                id: `profile-form.error.${data.error}`,
              })
            }
            disabled={field.disabled || loading}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={''}
            size={fieldSize}
            value={data.value || ''}
            dataAttributes={{ cy: field.name }}
            inputMode="email"
            type="email"
          />
        </div>
      )}
    </div>
  )
}

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'FC<InputFieldProps>' is not assi... Remove this comment to see the full error message
export default injectIntl(withMediaQuery(InputField))
